import ProgressionContainer from './progression-container'

export default ProgressionContainer
